"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("../../theme/makeStyles");
exports.default = (0, makeStyles_1.makeStyles)(function (theme) { return ({
    root: {
        flex: '1 1',
        justifyContent: 'center',
        textAlign: 'center',
        cursor: 'pointer'
    },
    input: {
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px',
        '&:focus-within + $labelText': {
            border: "2px solid ".concat(theme.colors.gray500),
            padding: ['9px', '12px']
        },
        '&:checked + $labelText': {
            transition: 'background-color .2s ease-in-out, bordor-color .2s ease-in-out',
            border: "2px solid ".concat(theme.colors["".concat(theme.colorFamily.forms, "400")]),
            padding: ['9px', '12px'],
            backgroundColor: theme.colors["".concat(theme.colorFamily.forms, "100")],
            '&:hover': {
                borderColor: theme.colors["".concat(theme.colorFamily.forms, "500")]
            }
        },
        '&:disabled': {
            '& + $labelText': {
                cursor: 'not-allowed',
                borderColor: theme.colors.gray300,
                color: theme.colors.gray300,
                '&:hover': {
                    borderColor: theme.colors.gray300,
                    borderWidth: '1px',
                    padding: ['10px', '12px']
                }
            },
            '&:checked + $labelText': {
                color: theme.colors.gray300,
                borderColor: theme.colors.gray300,
                backgroundColor: theme.colors.gray100,
                '&:hover': {
                    borderColor: theme.colors.gray300,
                    borderWidth: '2px',
                    padding: ['9px', '12px']
                }
            }
        }
    },
    labelText: {
        border: "1px solid ".concat(theme.colors.gray300),
        borderRadius: '4px',
        padding: ['10px', '12px'],
        transition: 'border-color .2s ease-in-out',
        width: '100%',
        '&:hover': {
            border: "2px solid ".concat(theme.colors.gray400),
            padding: ['9px', '12px']
        }
    },
    error: {
        border: "2px solid ".concat(theme.colors.warningAccessible),
        padding: ['9px', '12px']
    }
}); });
